<template>
  <div
    class="flex flex-col justify-center items-center flex-none w-auto px-3 mb-0 ds-text-xs font-medium leading-tight border border-transparent border-solid rounded-14px"
    style="height: 28px;"
  >
    <h2 class="block my-auto ds-text-xs">{{ genderPossessiveForm }} {{ sport }}</h2>
  </div>
</template>

<script>
export default {
    props: {
        sport: { type: String, required: true },
        gender: { type: String, default: '' },
    },
    computed: {
        genderPossessiveForm() {
            if(this.gender.length) 
                return this.gender === 'male' ?  "Men's" : "Women's"
            return this.gender
        },
    },
}

</script>

<style scoped>
.rounded-14px {
    border-radius: 14px;
}
</style>
